<template>
  <div class="card submission-card" v-bind:class="{ 'border border-warning': secondOp, 'border border-info': trialEditor, 'border border-danger': filter_phrases.length > 0  }">
    <div v-if="!numbered || !!header_text" class="card-header">
      <div class="row">
        <div class="col" v-if="!!header_text">
          <span>{{ header_text }}</span>
        </div>
        <div class="col" v-if="!numbered">
          <span class="float-right">This submission will be posted with no numbering</span>
        </div>
      </div>
    </div>
    <div class="card-body">
        <text-highlight class="submission-text" :queries="showFilterPhrases ? filter_phrases : []">{{ text }}</text-highlight>
        <br />
        <template v-if="image_url">
            <div v-if="this.nsfwImage" class="row m-4">
            <div class="col text-center">
                <button v-on:click="toggleImage" class="btn btn-warning">{{ this.showImage ? "Hide" : "Show" }} NSFW-flagged image</button>
            </div>
            </div>
            <img v-if="this.showImage" class="submittedImage d-block mx-auto img-fluid" :src="image_url" />
        </template>
    </div>
    <div class="card-footer py-1 submission-footer text-muted">
        <div class="d-flex justify-content-between flex-column flex-sm-row">
            <small v-if="filter_phrases.length > 0" class="p-1 text-right text-sm-center" @click="showFilterPhrases = !showFilterPhrases">
                <a>{{ showFilterPhrases ? 'Hide' : 'Show'}} Filter Hits</a>
            </small>
            <small v-if="trialEditor" class="p-1">Approved by Trial Editor</small>
            <small v-if="secondOp" class="p-1">Second opinion requested</small>
            <small class="p-1">
                Submitted: <nobr>{{ submissionTimeHumanReadable }}</nobr>
            </small>
            <small class="p-1" v-if="showRejectedTime">
                Rejected: <nobr>{{ decisionTimeHumanReadable }}</nobr>
            </small>
            <small class="p-1" v-if="showAcceptedTime">
                Accepted: <nobr>{{ decisionTimeHumanReadable }}</nobr>
            </small>
            <small class="p-1" v-if="showPostingTime">
                Posting: <nobr>{{ postingTimeHumanReadable }}</nobr>
            </small>
            <small class="p-1" v-if="showPostedTime">
                Posted: <nobr>{{ postedTimeHumanReadable }}</nobr>
            </small>
            <small class="p-1" v-if="showPostLink">
                <a :href="post_link">View on Facebook</a>
            </small>
            <small class="p-1 text-right text-sm-center" v-if="instagram">
                <i class="fab fa-instagram"></i>
            </small>
            <small class="p-1 text-right text-sm-center" v-if="showDetailsLink">
                <a :href="route_truth_details">Go to Details</a>
            </small>
            <small class="p-1 text-right text-sm-center" v-else>
                Status: <nobr><strong>{{ status }}</strong></nobr>
            </small>
        </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SubText",

  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    image_url: {
      type: String
    },
    submission_time: {
      type: String,
      required: true
    },
    decision_time: {
      type: String,
    },
    scheduled_post_time: {
      type: String,
    },
    route_truth_details: {
      type: String,
    },
    numbered: {
      type: Boolean,
      required: true
    },
    header_text: {
      type: String,
    },
    nsfw_probability: {
      type: Number
    },
    filter_phrases: {
      type: Array,
      default: () => []
    },
    posted_time: {
        type: String
    },
    post_link: {
        type: String
    },
    instagram: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nsfwImage: this.image_url && this.nsfw_probability > 0.95,
      showImage: !(this.image_url && this.nsfw_probability > 0.95),
      showFilterPhrases: false
    }
  },

  methods: {
    toggleImage: function() {
      this.showImage = !this.showImage;
    },
    timeDiff: function(datestamp) {
        // Safari doesn't support space seperated timestamps
        // https://stackoverflow.com/a/45152231
        let localDateTime = new Date(datestamp.replace(/ /g,"T") + "Z");
        return Math.floor((localDateTime - Date.now()) / 1000);
    },
    humanReadableTime: function(seconds) {
        let times = {           // Seconds in:
            "years": 31536000,  // a year
            "months": 2628000,  // a month
            "weeks": 604800,    // a week
            "days": 86400,      // a day
            "hours": 3600,      // an hour
            "minutes": 60,      // a minute
        }
        let future = seconds >= 0;
        seconds = Math.abs(seconds);
        for (let time in times) {
            let interval = Math.floor(seconds/times[time]);
            if (interval >= 1) {
                if (interval === 1) {
                    time = time.slice(0, -1);
                }
                return `${interval} ${time} ${future ? 'from now' : 'ago'}`;
            }
        }
        return `${Math.floor(seconds)} seconds ${future ? 'from now' : 'ago'}`;
    },
  },

  computed: {
    showPostingTime: function() {
      return this.scheduled_post_time != null && this.status == "Accepted";
    },
    showPostedTime: function() {
      return !!this.posted_time;
    },
    showAcceptedTime: function() {
      return this.decision_time != null && this.status == "Accepted";
    },
    showRejectedTime: function() {
      return this.decision_time != null && this.status == "Rejected";
    },
    showDetailsLink: function() {
        return !!this.route_truth_details;
    },
    showPostLink: function() {
        return !!this.post_link;
    },
    trialEditor: function() {
        return this.status == "EditorOp";
    },
    secondOp: function() {
        return this.status == "2ndOpinion";
    },
    submissionTimeHumanReadable: function() {
        return this.humanReadableTime(this.timeDiff(this.submission_time));
    },
    decisionTimeHumanReadable: function() {
        return this.humanReadableTime(this.timeDiff(this.decision_time));
    },
    postedTimeHumanReadable: function() {
        return this.humanReadableTime(this.timeDiff(this.posted_time));
    },
    postingTimeHumanReadable: function() {
        let postingTimeDiff = this.timeDiff(this.scheduled_post_time);
      if (postingTimeDiff < 0) {
        //Within 1 minute
        return "Overdue";
      } else if (postingTimeDiff < 60) {
        //in the past
        return "Due";
      } else {
        return this.humanReadableTime(postingTimeDiff);
      }
    },
  },
};

</script>

<style scoped>
  .submission-text {
    white-space: pre-line;
  }
  .submission-text > mark {
    padding: 0;
  }
</style>